'use es6';

import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const MenuTree = /*#__PURE__*/forwardRef(({
  isCollapsed = false,
  isParentDragging,
  readOnly,
  nodes,
  menuId,
  parentId,
  depth,
  depthToNextSibling = 0,
  hierarchy = [],
  getMenuComponent,
  moveNode
}, ref) => {
  const MenuNodeComponent = getMenuComponent(false);
  const menuTreeBlockSize = isCollapsed ? '0' : undefined;
  const menuTreeOverflowY = isCollapsed ? 'hidden' : undefined;
  const menuTreeMarginInlineStart = parentId ? '600' : undefined;
  return /*#__PURE__*/_jsx(View, {
    ref: ref,
    position: "relative",
    blockSize: menuTreeBlockSize,
    overflowY: menuTreeOverflowY,
    marginInlineStart: menuTreeMarginInlineStart,
    children: /*#__PURE__*/_jsx(FlipMove, {
      duration: 200,
      easing: "cubic-bezier(.42, .0, .58, 1)",
      children: !isCollapsed && nodes.map((node, index) => {
        const hasSibling = index < nodes.length - 1;
        const isLastChild = index === nodes.length - 1;
        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(MenuNodeComponent, Object.assign({
            isParentDragging: isParentDragging,
            isLastChild: isLastChild,
            hasSibling: hasSibling,
            readOnly: readOnly,
            index: index,
            menuId: menuId,
            parentId: parentId
          }, node, {
            depth: depth,
            depthToNextSibling: hasSibling || depth === 0 ? 0 : depthToNextSibling + 1,
            hierarchy: hierarchy,
            getMenuComponent: getMenuComponent,
            moveNode: moveNode
          }))
        }, node.id);
      })
    })
  });
});
MenuTree.propTypes = {
  isCollapsed: PropTypes.bool,
  isParentDragging: PropTypes.bool,
  readOnly: PropTypes.bool,
  // replace any with node model
  nodes: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  depth: PropTypes.number,
  depthToNextSibling: PropTypes.number,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  getMenuComponent: PropTypes.func.isRequired,
  moveNode: PropTypes.func.isRequired
};
export default MenuTree;